<sans-dashboard
  [game]="contractDeclarationGame"
  [talonCards]="talonCards"
  [userCards]="userCards"
  [rightOpponentCards]="rightOpponentCards"
  [leftOpponentCards]="leftOpponentCards"
  [isUserCardsSelectable]="isUserCardsSelectable"
  [userPlayerScoreCard]="userPlayerScoreCard"
  [leftOpponentPlayerScoreCard]="leftOpponentPlayerScoreCard"
  [rightOpponentPlayerScoreCard]="rightOpponentPlayerScoreCard"
  (userCardSelected)="onUserCardSelected($event)"
  (talonCardSelected)="onTalonCardSelected($event)"
  [userActions]="userActions"
  (userActionSelected)="onUserActionSelected($event)"
>
</sans-dashboard>
